import { createServerFn } from "@tanstack/solid-start";
import { z } from "zod";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const AccountOverviewInputSchema = z.object({
  businessId: z.string().trim().min(1),
});

export const AccountOverviewTypeSchema = z.enum([
  "asset",
  "equity",
  "liability",
  "revenue",
  "expense",
]);

export const AccountTypeOverviewInputSchema = z.object({
  businessId: z.string().trim().min(1),
  type: AccountOverviewTypeSchema,
});

export const getAccountOverview = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => AccountOverviewInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("accountOverview.get", async () => {
      const { getAccountOverviewForUser } =
        await import("./account-overview.server");
      return getAccountOverviewForUser(context.user.id, data.businessId);
    });
  });

export const getAccountTypeOverview = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => AccountTypeOverviewInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("accountOverview.getType", async () => {
      const { getAccountTypeOverviewForUser } =
        await import("./account-overview.server");
      return getAccountTypeOverviewForUser(
        context.user.id,
        data.businessId,
        data.type,
      );
    });
  });
